/**
 * Andys rent pick-up locations (#1108) — the rental page's own pick-up list,
 * same names and order (#1469; andys-motors.com/car-rental, the Wheelsystems
 * engine's `wheelsBookingEngine.locations`, checked 2026-10-07).
 *
 * `engineCode` — the engine's location Code. The engine doesn't read codes
 * from the query string; the config-driven prefill bridge selects the code
 * through the engine's own selectLocation() on `/car-rental`. A location the
 * engine doesn't have can't be selected, and then no search starts — so this
 * list must stay the engine's (Nicosia, which it doesn't have, was dropped).
 *
 * Not here: Pissouri village (PSU) — in the engine's data, but the rental
 * page doesn't offer it for pick-up.
 */
export const ANDYS_RENT_LOCATIONS = [
  { value: 'akrotiri-airport', label: 'Akrotiri airport terminal', engineCode: 'AKI 1' },
  { value: 'akrotiri-car-park', label: 'Akrotiri car park (next to terminal)', engineCode: 'AKI2' },
  { value: 'ayios-nikolaos', label: 'Ayios Nikolaos camp', engineCode: 'AYNIK' },
  { value: 'dhekelia', label: 'Dhekelia Camp', engineCode: 'DHK1' },
  { value: 'episkopi', label: 'Episkopi base car park', engineCode: 'EPI3' },
  { value: 'larnaca-airport', label: 'Larnaca airport', engineCode: 'LCA1' },
  { value: 'limassol-office', label: 'Limassol office', engineCode: 'SHR' },
  { value: 'paphos-airport', label: 'Paphos airport', engineCode: 'PFO1' },
  { value: 'paphos-city', label: 'Paphos city', engineCode: 'PFO2' },
];

/** Preselected on the landing: Andys' main office in Limassol. */
export const ANDYS_RENT_DEFAULT_LOCATION = 'limassol-office';

/** Wheelsystems booking engine page — куда уводит "Check availability". */
export const ANDYS_RENTAL_ENGINE_URL = 'https://andys-motors.com/car-rental';

export default ANDYS_RENT_LOCATIONS;
